import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-white/10 bg-ink" data-id="element-65" data-mp="3gfitaf6445cj">
      <div className="mx-auto max-w-4xl px-5 py-12 text-center" data-id="element-66" data-mp="3gh3sii3dgcgq">
        <p className="font-display text-xl font-black text-white" data-id="element-67" data-mp="32pfeuadh5fxn">
          THE ACADEMIC EDGE<span className="align-super text-xs" data-id="element-68" data-mp="36qhdaozkhnyk">™</span>
        </p>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-white/60" data-id="element-69" data-mp="3ufa64ckw7foy">
          The #1 method and academic performance system for university students in the USA, UK,
          Canada & Australia. Because studying hard shouldn't cost you another year of your degree.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-white/70" data-id="element-70" data-mp="3qd6r5dz0lsyx">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors hover:text-gold" data-id="element-71" data-mp="29ynlrlrph7ej">
            <MailIcon className="h-4 w-4 text-gold" data-id="element-72" data-mp="2evxat0b6nh1u" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors hover:text-gold" data-id="element-73" data-mp="3lbddkvg7mdmv">
            <InstagramIcon className="h-4 w-4 text-gold" data-id="element-74" data-mp="3gctrmv1m91ui" /> @sigmasmartoficial
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors hover:text-gold" data-id="element-75" data-mp="3v5n6ce92ddy4">
            <GlobeIcon className="h-4 w-4 text-gold" data-id="element-76" data-mp="3qapwx67vh2kp" /> www.sigmasmart.store
          </a>
        </div>

        <p className="mt-4 font-display text-base font-semibold italic text-gold" data-id="element-77" data-mp="80nrsermsiar">
          🎓 “The next exam can be different.”
        </p>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-white/40" data-id="element-78" data-mp="ht3bbgiktexr">
          <a href="#" className="transition-colors hover:text-white/70" data-id="element-79" data-mp="cth01cmb68rl">
            Terms & Conditions
          </a>
          <span data-id="element-80" data-mp="qub97xh6kdrb">·</span>
          <a href="#" className="transition-colors hover:text-white/70" data-id="element-81" data-mp="qrfai6xidl1t">
            Privacy Policy
          </a>
          <span data-id="element-82" data-mp="mq3gzqbikfoc">·</span>
          <a href="#" className="transition-colors hover:text-white/70" data-id="element-83" data-mp="tvmqbhqesglw">
            Support
          </a>
        </div>

        <p className="mt-8 text-xs leading-relaxed text-white/35" data-id="element-84" data-mp="yv92royexstn">
          © 2026 THE ACADEMIC EDGE™ — SIGMA SMART™ — All rights reserved. Reproduction and
          redistribution prohibited without express authorization.
        </p>
      </div>
    </footer>;
}